/// <amd-module name="TestPlanCommon/RestClient/TestPlan" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\testmanagement\vss-test-web\testplancommon\restclient\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";
import { deserializeVssJsonObject } from "VSS/Platform/Util/Serialization";

import * as TestPlan from "TestPlanCommon/Contracts/TestPlan";
import * as VS_Services from "VSS/Platform/Contracts/WebApi";

export interface ITestPlanRestClient extends IVssRestClient {
    /**
     * @param project - Project ID or project name
     * @param planId - 
     * @param states - 
     * @param outcome - 
     * @param configurations - 
     * @param testers - 
     * @param assignedTo - 
     * @param entity - 
     */
    getTestEntityCountByPlanId(project: string, planId: number, states?: string, outcome?: TestPlan.UserFriendlyTestOutcome, configurations?: string, testers?: string, assignedTo?: string, entity?: TestPlan.TestEntityTypes): Promise<TestPlan.TestEntityCount[]>;
    /**
     * Create a test plan.
     * 
     * @param testPlanCreateParams - A testPlanCreateParams object.TestPlanCreateParams
     * @param project - Project ID or project name
     */
    createTestPlan(testPlanCreateParams: TestPlan.TestPlanCreateParams, project: string): Promise<TestPlan.TestPlan>;
    /**
     * Get a test plan by Id.
     * 
     * @param project - Project ID or project name
     * @param planId - ID of the test plan to get.
     */
    getTestPlanById(project: string, planId: number): Promise<TestPlan.TestPlan>;
    /**
     * Get a list of test plans
     * 
     * @param project - Project ID or project name
     * @param owner - Filter for test plan by owner ID or name
     * @param continuationToken - If the list of plans returned is not complete, a continuation token to query next batch of plans is included in the response header as "x-ms-continuationtoken". Omit this parameter to get the first batch of test plans.
     * @param includePlanDetails - Get all properties of the test plan
     * @param filterActivePlans - Get just the active plans
     */
    getTestPlans(project: string, owner?: string, continuationToken?: string, includePlanDetails?: boolean, filterActivePlans?: boolean): Promise<VS_Services.PagedList<TestPlan.TestPlan>>;
    /**
     * Reorder test suite entries in the test suite.
     * 
     * @param suiteEntries - List of SuiteEntry to reorder.
     * @param project - Project ID or project name
     * @param suiteId - Id of the parent test suite.
     */
    reorderSuiteEntries(suiteEntries: TestPlan.SuiteEntryUpdateParams[], project: string, suiteId: number): Promise<TestPlan.SuiteEntry[]>;
    /**
     * Create bulk requirement based test suites.
     * 
     * @param testSuiteCreateParams - Parameters for suite creation
     * @param project - Project ID or project name
     * @param planId - ID of the test plan where requirement based suites need to be created.
     * @param parentSuiteId - ID of the parent suite under which requirement based suites will be created
     */
    createBulkTestSuites(testSuiteCreateParams: TestPlan.TestSuiteCreateParams[], project: string, planId: number, parentSuiteId: number): Promise<TestPlan.TestSuite[]>;
    /**
     * Create test suite.
     * 
     * @param testSuiteCreateParams - Parameters for suite creation
     * @param project - Project ID or project name
     * @param planId - ID of the test plan that contains the suites.
     */
    createTestSuite(testSuiteCreateParams: TestPlan.TestSuiteCreateParams, project: string, planId: number): Promise<TestPlan.TestSuite>;
    /**
     * Delete test suite.
     * 
     * @param project - Project ID or project name
     * @param planId - ID of the test plan that contains the suite.
     * @param suiteId - ID of the test suite to delete.
     */
    deleteTestSuite(project: string, planId: number, suiteId: number): Promise<void>;
    /**
     * Get test suites for plan.
     * 
     * @param project - Project ID or project name
     * @param planId - ID of the test plan for which suites are requested.
     * @param expand - Include the children suites and testers details.
     * @param continuationToken - If the list of suites returned is not complete, a continuation token to query next batch of suites is included in the response header as "x-ms-continuationtoken". Omit this parameter to get the first batch of test suites.
     * @param asTreeView - If the suites returned should be in a tree structure.
     */
    getTestSuitesForPlan(project: string, planId: number, expand?: TestPlan.SuiteExpand, continuationToken?: string, asTreeView?: boolean): Promise<VS_Services.PagedList<TestPlan.TestSuite>>;
    /**
     * Update test suite.
     * 
     * @param testSuiteUpdateParams - Parameters for suite updation
     * @param project - Project ID or project name
     * @param planId - ID of the test plan that contains the suites.
     * @param suiteId - ID of the parent suite.
     */
    updateTestSuite(testSuiteUpdateParams: TestPlan.TestSuiteUpdateParams, project: string, planId: number, suiteId: number): Promise<TestPlan.TestSuite>;
    /**
     * Find the list of all test suites in which a given test case is present. This is helpful if you need to find out which test suites are using a test case, when you need to make changes to a test case.
     * 
     * @param testCaseId - ID of the test case for which suites need to be fetched.
     */
    getSuitesByTestCaseId(testCaseId: number): Promise<TestPlan.TestSuite[]>;
    /**
     * Add test cases to a suite with specified configurations
     * 
     * @param suiteTestCaseCreateUpdateParameters - SuiteTestCaseCreateUpdateParameters object.
     * @param project - Project ID or project name
     * @param planId - ID of the test plan to which test cases are to be added.
     * @param suiteId - ID of the test suite to which test cases are to be added.
     */
    addTestCasesToSuite(suiteTestCaseCreateUpdateParameters: TestPlan.SuiteTestCaseCreateUpdateParameters[], project: string, planId: number, suiteId: number): Promise<TestPlan.TestCase[]>;
    /**
     * Get a particular Test Case from a Suite.
     * 
     * @param project - Project ID or project name
     * @param planId - ID of the test plan for which test cases are requested.
     * @param suiteId - ID of the test suite for which test cases are requested.
     * @param testCaseId - Test Case Id to be fetched.
     * @param witFields - Get the list of witFields.
     * @param returnIdentityRef - If set to true, returns all identity fields, like AssignedTo, ActivatedBy etc., as IdentityRef objects. If set to false, these fields are returned as unique names in string format. This is false by default.
     */
    getTestCase(project: string, planId: number, suiteId: number, testCaseId: string, witFields?: string, returnIdentityRef?: boolean): Promise<TestPlan.TestCase[]>;
    /**
     * Get Test Case List return those test cases which have all the configuration Ids as mentioned in the optional parameter. If configuration Ids is null, it return all the test cases
     * 
     * @param project - Project ID or project name
     * @param planId - ID of the test plan for which test cases are requested.
     * @param suiteId - ID of the test suite for which test cases are requested.
     * @param testIds - Test Case Ids to be fetched.
     * @param configurationIds - Fetch Test Cases which contains all the configuration Ids specified.
     * @param witFields - Get the list of witFields.
     * @param continuationToken - If the list of test cases returned is not complete, a continuation token to query next batch of test cases is included in the response header as "x-ms-continuationtoken". Omit this parameter to get the first batch of test cases.
     * @param returnIdentityRef - If set to true, returns all identity fields, like AssignedTo, ActivatedBy etc., as IdentityRef objects. If set to false, these fields are returned as unique names in string format. This is false by default.
     * @param expand - If set to false, will get a smaller payload containing only basic details about the suite test case object
     * @param excludeFlags - Flag to exclude various values from payload. For example to remove point assignments pass exclude = 1. To remove extra information (links, test plan , test suite) pass exclude = 2. To remove both extra information and point assignments pass exclude = 3 (1 + 2).
     * @param isRecursive - 
     */
    getTestCaseList(project: string, planId: number, suiteId: number, testIds?: string, configurationIds?: string, witFields?: string, continuationToken?: string, returnIdentityRef?: boolean, expand?: boolean, excludeFlags?: TestPlan.ExcludeFlags, isRecursive?: boolean): Promise<VS_Services.PagedList<TestPlan.TestCase>>;
    /**
     * Removes test cases from a suite based on the list of test case Ids provided. This API can be used to remove a larger number of test cases.
     * 
     * @param project - Project ID or project name
     * @param planId - ID of the test plan from which test cases are to be removed.
     * @param suiteId - ID of the test suite from which test cases are to be removed.
     * @param testIds - Comma separated string of Test Case Ids to be removed.
     */
    removeTestCasesListFromSuite(project: string, planId: number, suiteId: number, testIds: string): Promise<void>;
    /**
     * @param cloneRequestBody - 
     * @param project - Project ID or project name
     */
    cloneTestCase(cloneRequestBody: TestPlan.CloneTestCaseParams, project: string): Promise<TestPlan.CloneTestCaseOperationInformation>;
    /**
     * Get clone information.
     * 
     * @param project - Project ID or project name
     * @param cloneOperationId - Operation ID returned when we queue a clone operation
     */
    getTestCaseCloneInformation(project: string, cloneOperationId: number): Promise<TestPlan.CloneTestCaseOperationInformation>;
    /**
     * Exports a set of test cases from a suite to a file. Currently supported  formats: xlsx
     * 
     * @param exportTestCaseRequestBody - A ExportTestCaseParams object.ExportTestCaseParams
     * @param project - Project ID or project name
     */
    exportTestCases(exportTestCaseRequestBody: TestPlan.ExportTestCaseParams, project: string): Promise<ArrayBuffer>;
    /**
     * Clone test plan
     * 
     * @param cloneRequestBody - Plan Clone Request Body detail TestPlanCloneRequest
     * @param project - Project ID or project name
     * @param deepClone - Clones all the associated test cases as well
     */
    cloneTestPlan(cloneRequestBody: TestPlan.CloneTestPlanParams, project: string, deepClone?: boolean): Promise<TestPlan.CloneTestPlanOperationInformation>;
    /**
     * Get clone information.
     * 
     * @param project - Project ID or project name
     * @param cloneOperationId - Operation ID returned when we queue a clone operation
     */
    getCloneInformation(project: string, cloneOperationId: number): Promise<TestPlan.CloneTestPlanOperationInformation>;
    /**
     * Get all the points inside a suite based on some filters
     * 
     * @param project - Project ID or project name
     * @param planId - ID of the test plan for which test points are requested.
     * @param suiteId - ID of the test suite for which test points are requested
     * @param testPointIds - ID of test points to fetch.
     * @param testCaseId - Get Test Points for specific test case Ids.
     * @param continuationToken - If the list of test point returned is not complete, a continuation token to query next batch of test points is included in the response header as "x-ms-continuationtoken". Omit this parameter to get the first batch of test points.
     * @param returnIdentityRef - If set to true, returns the AssignedTo field in TestCaseReference as IdentityRef object.
     * @param includePointDetails - If set to false, will get a smaller payload containing only basic details about the test point object
     * @param isRecursive - If set to true, will also fetch test points belonging to child suites recursively.
     */
    getPointsList(project: string, planId: number, suiteId: number, testPointIds?: string, testCaseId?: string, continuationToken?: string, returnIdentityRef?: boolean, includePointDetails?: boolean, isRecursive?: boolean): Promise<VS_Services.PagedList<TestPlan.TestPoint>>;
    /**
     * Update Test Points. This is used to Reset test point to active, update the outcome of a test point or update the tester of a test point
     * 
     * @param testPointUpdateParams - A TestPointUpdateParams Object.
     * @param project - Project ID or project name
     * @param planId - ID of the test plan for which test points are requested.
     * @param suiteId - ID of the test suite for which test points are requested.
     * @param includePointDetails - If set to false, will get a smaller payload containing only basic details about the test point object
     * @param returnIdentityRef - If set to true, returns the AssignedTo field in TestCaseReference as IdentityRef object.
     */
    updateTestPoints(testPointUpdateParams: TestPlan.TestPointUpdateParams[], project: string, planId: number, suiteId: number, includePointDetails?: boolean, returnIdentityRef?: boolean): Promise<TestPlan.TestPoint[]>;
    /**
     * Clone test suite
     * 
     * @param cloneRequestBody - Suite Clone Request Body detail TestSuiteCloneRequest
     * @param project - Project ID or project name
     * @param deepClone - Clones all the associated test cases as well
     */
    cloneTestSuite(cloneRequestBody: TestPlan.CloneTestSuiteParams, project: string, deepClone?: boolean): Promise<TestPlan.CloneTestSuiteOperationInformation>;
    /**
     * Get clone information.
     * 
     * @param project - Project ID or project name
     * @param cloneOperationId - Operation ID returned when we queue a clone operation
     */
    getSuiteCloneInformation(project: string, cloneOperationId: number): Promise<TestPlan.CloneTestSuiteOperationInformation>;
}

class TestPlanRestClient extends RestClientBase implements ITestPlanRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * @param project - Project ID or project name
     * @param planId - 
     * @param states - 
     * @param outcome - 
     * @param configurations - 
     * @param testers - 
     * @param assignedTo - 
     * @param entity - 
     */
    public async getTestEntityCountByPlanId(
        project: string,
        planId: number,
        states?: string,
        outcome?: TestPlan.UserFriendlyTestOutcome,
        configurations?: string,
        testers?: string,
        assignedTo?: string,
        entity?: TestPlan.TestEntityTypes
        ): Promise<TestPlan.TestEntityCount[]> {

        const queryValues: any = {
            states: states,
            outcome: outcome,
            configurations: configurations,
            testers: testers,
            assignedTo: assignedTo,
            entity: entity
        };

        return this.beginRequest<TestPlan.TestEntityCount[]>({
            apiVersion: "7.1-preview.1",
            routeTemplate: "{project}/_apis/testplan/Count/{planId}",
            routeValues: {
                project: project,
                planId: planId
            },
            queryParams: queryValues
        });
    }

    /**
     * Create a test plan.
     * 
     * @param testPlanCreateParams - A testPlanCreateParams object.TestPlanCreateParams
     * @param project - Project ID or project name
     */
    public async createTestPlan(
        testPlanCreateParams: TestPlan.TestPlanCreateParams,
        project: string
        ): Promise<TestPlan.TestPlan> {

        return this.beginRequest<TestPlan.TestPlan>({
            apiVersion: "7.1-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/testplan/Plans/{planId}",
            routeValues: {
                project: project
            },
            body: testPlanCreateParams
        });
    }

    /**
     * Get a test plan by Id.
     * 
     * @param project - Project ID or project name
     * @param planId - ID of the test plan to get.
     */
    public async getTestPlanById(
        project: string,
        planId: number
        ): Promise<TestPlan.TestPlan> {

        return this.beginRequest<TestPlan.TestPlan>({
            apiVersion: "7.1-preview.1",
            routeTemplate: "{project}/_apis/testplan/Plans/{planId}",
            routeValues: {
                project: project,
                planId: planId
            }
        });
    }

    /**
     * Get a list of test plans
     * 
     * @param project - Project ID or project name
     * @param owner - Filter for test plan by owner ID or name
     * @param continuationToken - If the list of plans returned is not complete, a continuation token to query next batch of plans is included in the response header as "x-ms-continuationtoken". Omit this parameter to get the first batch of test plans.
     * @param includePlanDetails - Get all properties of the test plan
     * @param filterActivePlans - Get just the active plans
     */
    public async getTestPlans(
        project: string,
        owner?: string,
        continuationToken?: string,
        includePlanDetails?: boolean,
        filterActivePlans?: boolean
        ): Promise<VS_Services.PagedList<TestPlan.TestPlan>> {

        const queryValues: any = {
            owner: owner,
            continuationToken: continuationToken,
            includePlanDetails: includePlanDetails,
            filterActivePlans: filterActivePlans
        };

        return this.beginRequest<Response>({
            apiVersion: "7.1-preview.1",
            routeTemplate: "{project}/_apis/testplan/Plans/{planId}",
            routeValues: {
                project: project
            },
            queryParams: queryValues,
            returnRawResponse: true
        }).then(async response => {
            const body = <VS_Services.PagedList<TestPlan.TestPlan>>await response.text().then(deserializeVssJsonObject);
            body.continuationToken = response.headers.get("x-ms-continuationtoken");
            return body;
        });
    }

    /**
     * Reorder test suite entries in the test suite.
     * 
     * @param suiteEntries - List of SuiteEntry to reorder.
     * @param project - Project ID or project name
     * @param suiteId - Id of the parent test suite.
     */
    public async reorderSuiteEntries(
        suiteEntries: TestPlan.SuiteEntryUpdateParams[],
        project: string,
        suiteId: number
        ): Promise<TestPlan.SuiteEntry[]> {

        return this.beginRequest<TestPlan.SuiteEntry[]>({
            apiVersion: "7.1-preview.1",
            method: "PATCH",
            routeTemplate: "{project}/_apis/testplan/SuiteEntry/{suiteId}",
            routeValues: {
                project: project,
                suiteId: suiteId
            },
            body: suiteEntries
        });
    }

    /**
     * Create bulk requirement based test suites.
     * 
     * @param testSuiteCreateParams - Parameters for suite creation
     * @param project - Project ID or project name
     * @param planId - ID of the test plan where requirement based suites need to be created.
     * @param parentSuiteId - ID of the parent suite under which requirement based suites will be created
     */
    public async createBulkTestSuites(
        testSuiteCreateParams: TestPlan.TestSuiteCreateParams[],
        project: string,
        planId: number,
        parentSuiteId: number
        ): Promise<TestPlan.TestSuite[]> {

        return this.beginRequest<TestPlan.TestSuite[]>({
            apiVersion: "7.1-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/testplan/Plans/{planId}/Suites/{parentSuiteId}/bulk",
            routeValues: {
                project: project,
                planId: planId,
                parentSuiteId: parentSuiteId
            },
            body: testSuiteCreateParams
        });
    }

    /**
     * Create test suite.
     * 
     * @param testSuiteCreateParams - Parameters for suite creation
     * @param project - Project ID or project name
     * @param planId - ID of the test plan that contains the suites.
     */
    public async createTestSuite(
        testSuiteCreateParams: TestPlan.TestSuiteCreateParams,
        project: string,
        planId: number
        ): Promise<TestPlan.TestSuite> {

        return this.beginRequest<TestPlan.TestSuite>({
            apiVersion: "7.1-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/testplan/Plans/{planId}/Suites/{suiteId}",
            routeValues: {
                project: project,
                planId: planId
            },
            body: testSuiteCreateParams
        });
    }

    /**
     * Delete test suite.
     * 
     * @param project - Project ID or project name
     * @param planId - ID of the test plan that contains the suite.
     * @param suiteId - ID of the test suite to delete.
     */
    public async deleteTestSuite(
        project: string,
        planId: number,
        suiteId: number
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "7.1-preview.1",
            method: "DELETE",
            routeTemplate: "{project}/_apis/testplan/Plans/{planId}/Suites/{suiteId}",
            routeValues: {
                project: project,
                planId: planId,
                suiteId: suiteId
            }
        });
    }

    /**
     * Get test suites for plan.
     * 
     * @param project - Project ID or project name
     * @param planId - ID of the test plan for which suites are requested.
     * @param expand - Include the children suites and testers details.
     * @param continuationToken - If the list of suites returned is not complete, a continuation token to query next batch of suites is included in the response header as "x-ms-continuationtoken". Omit this parameter to get the first batch of test suites.
     * @param asTreeView - If the suites returned should be in a tree structure.
     */
    public async getTestSuitesForPlan(
        project: string,
        planId: number,
        expand?: TestPlan.SuiteExpand,
        continuationToken?: string,
        asTreeView?: boolean
        ): Promise<VS_Services.PagedList<TestPlan.TestSuite>> {

        const queryValues: any = {
            expand: expand,
            continuationToken: continuationToken,
            asTreeView: asTreeView
        };

        return this.beginRequest<Response>({
            apiVersion: "7.1-preview.1",
            routeTemplate: "{project}/_apis/testplan/Plans/{planId}/Suites/{suiteId}",
            routeValues: {
                project: project,
                planId: planId
            },
            queryParams: queryValues,
            returnRawResponse: true
        }).then(async response => {
            const body = <VS_Services.PagedList<TestPlan.TestSuite>>await response.text().then(deserializeVssJsonObject);
            body.continuationToken = response.headers.get("x-ms-continuationtoken");
            return body;
        });
    }

    /**
     * Update test suite.
     * 
     * @param testSuiteUpdateParams - Parameters for suite updation
     * @param project - Project ID or project name
     * @param planId - ID of the test plan that contains the suites.
     * @param suiteId - ID of the parent suite.
     */
    public async updateTestSuite(
        testSuiteUpdateParams: TestPlan.TestSuiteUpdateParams,
        project: string,
        planId: number,
        suiteId: number
        ): Promise<TestPlan.TestSuite> {

        return this.beginRequest<TestPlan.TestSuite>({
            apiVersion: "7.1-preview.1",
            method: "PATCH",
            routeTemplate: "{project}/_apis/testplan/Plans/{planId}/Suites/{suiteId}",
            routeValues: {
                project: project,
                planId: planId,
                suiteId: suiteId
            },
            body: testSuiteUpdateParams
        });
    }

    /**
     * Find the list of all test suites in which a given test case is present. This is helpful if you need to find out which test suites are using a test case, when you need to make changes to a test case.
     * 
     * @param testCaseId - ID of the test case for which suites need to be fetched.
     */
    public async getSuitesByTestCaseId(
        testCaseId: number
        ): Promise<TestPlan.TestSuite[]> {

        const queryValues: any = {
            testCaseId: testCaseId
        };

        return this.beginRequest<TestPlan.TestSuite[]>({
            apiVersion: "7.1-preview.1",
            routeTemplate: "_apis/testplan/Suites",
            queryParams: queryValues
        });
    }

    /**
     * Add test cases to a suite with specified configurations
     * 
     * @param suiteTestCaseCreateUpdateParameters - SuiteTestCaseCreateUpdateParameters object.
     * @param project - Project ID or project name
     * @param planId - ID of the test plan to which test cases are to be added.
     * @param suiteId - ID of the test suite to which test cases are to be added.
     */
    public async addTestCasesToSuite(
        suiteTestCaseCreateUpdateParameters: TestPlan.SuiteTestCaseCreateUpdateParameters[],
        project: string,
        planId: number,
        suiteId: number
        ): Promise<TestPlan.TestCase[]> {

        return this.beginRequest<TestPlan.TestCase[]>({
            apiVersion: "7.1-preview.3",
            method: "POST",
            routeTemplate: "{project}/_apis/testplan/Plans/{planId}/Suites/{suiteId}/TestCase/{testCaseId}",
            routeValues: {
                project: project,
                planId: planId,
                suiteId: suiteId
            },
            body: suiteTestCaseCreateUpdateParameters
        });
    }

    /**
     * Get a particular Test Case from a Suite.
     * 
     * @param project - Project ID or project name
     * @param planId - ID of the test plan for which test cases are requested.
     * @param suiteId - ID of the test suite for which test cases are requested.
     * @param testCaseId - Test Case Id to be fetched.
     * @param witFields - Get the list of witFields.
     * @param returnIdentityRef - If set to true, returns all identity fields, like AssignedTo, ActivatedBy etc., as IdentityRef objects. If set to false, these fields are returned as unique names in string format. This is false by default.
     */
    public async getTestCase(
        project: string,
        planId: number,
        suiteId: number,
        testCaseId: string,
        witFields?: string,
        returnIdentityRef?: boolean
        ): Promise<TestPlan.TestCase[]> {

        const queryValues: any = {
            witFields: witFields,
            returnIdentityRef: returnIdentityRef
        };

        return this.beginRequest<TestPlan.TestCase[]>({
            apiVersion: "7.1-preview.3",
            routeTemplate: "{project}/_apis/testplan/Plans/{planId}/Suites/{suiteId}/TestCase/{testCaseId}",
            routeValues: {
                project: project,
                planId: planId,
                suiteId: suiteId,
                testCaseId: testCaseId
            },
            queryParams: queryValues
        });
    }

    /**
     * Get Test Case List return those test cases which have all the configuration Ids as mentioned in the optional parameter. If configuration Ids is null, it return all the test cases
     * 
     * @param project - Project ID or project name
     * @param planId - ID of the test plan for which test cases are requested.
     * @param suiteId - ID of the test suite for which test cases are requested.
     * @param testIds - Test Case Ids to be fetched.
     * @param configurationIds - Fetch Test Cases which contains all the configuration Ids specified.
     * @param witFields - Get the list of witFields.
     * @param continuationToken - If the list of test cases returned is not complete, a continuation token to query next batch of test cases is included in the response header as "x-ms-continuationtoken". Omit this parameter to get the first batch of test cases.
     * @param returnIdentityRef - If set to true, returns all identity fields, like AssignedTo, ActivatedBy etc., as IdentityRef objects. If set to false, these fields are returned as unique names in string format. This is false by default.
     * @param expand - If set to false, will get a smaller payload containing only basic details about the suite test case object
     * @param excludeFlags - Flag to exclude various values from payload. For example to remove point assignments pass exclude = 1. To remove extra information (links, test plan , test suite) pass exclude = 2. To remove both extra information and point assignments pass exclude = 3 (1 + 2).
     * @param isRecursive - 
     */
    public async getTestCaseList(
        project: string,
        planId: number,
        suiteId: number,
        testIds?: string,
        configurationIds?: string,
        witFields?: string,
        continuationToken?: string,
        returnIdentityRef?: boolean,
        expand?: boolean,
        excludeFlags?: TestPlan.ExcludeFlags,
        isRecursive?: boolean
        ): Promise<VS_Services.PagedList<TestPlan.TestCase>> {

        const queryValues: any = {
            testIds: testIds,
            configurationIds: configurationIds,
            witFields: witFields,
            continuationToken: continuationToken,
            returnIdentityRef: returnIdentityRef,
            expand: expand,
            excludeFlags: excludeFlags,
            isRecursive: isRecursive
        };

        return this.beginRequest<Response>({
            apiVersion: "7.1-preview.3",
            routeTemplate: "{project}/_apis/testplan/Plans/{planId}/Suites/{suiteId}/TestCase/{testCaseId}",
            routeValues: {
                project: project,
                planId: planId,
                suiteId: suiteId
            },
            queryParams: queryValues,
            returnRawResponse: true
        }).then(async response => {
            const body = <VS_Services.PagedList<TestPlan.TestCase>>await response.text().then(deserializeVssJsonObject);
            body.continuationToken = response.headers.get("x-ms-continuationtoken");
            return body;
        });
    }

    /**
     * Removes test cases from a suite based on the list of test case Ids provided. This API can be used to remove a larger number of test cases.
     * 
     * @param project - Project ID or project name
     * @param planId - ID of the test plan from which test cases are to be removed.
     * @param suiteId - ID of the test suite from which test cases are to be removed.
     * @param testIds - Comma separated string of Test Case Ids to be removed.
     */
    public async removeTestCasesListFromSuite(
        project: string,
        planId: number,
        suiteId: number,
        testIds: string
        ): Promise<void> {

        const queryValues: any = {
            testIds: testIds
        };

        return this.beginRequest<void>({
            apiVersion: "7.1-preview.3",
            method: "DELETE",
            routeTemplate: "{project}/_apis/testplan/Plans/{planId}/Suites/{suiteId}/TestCase/{testCaseId}",
            routeValues: {
                project: project,
                planId: planId,
                suiteId: suiteId
            },
            queryParams: queryValues
        });
    }

    /**
     * @param cloneRequestBody - 
     * @param project - Project ID or project name
     */
    public async cloneTestCase(
        cloneRequestBody: TestPlan.CloneTestCaseParams,
        project: string
        ): Promise<TestPlan.CloneTestCaseOperationInformation> {

        return this.beginRequest<TestPlan.CloneTestCaseOperationInformation>({
            apiVersion: "7.1-preview.2",
            method: "POST",
            routeTemplate: "{project}/_apis/testplan/TestCases/CloneTestCaseOperation/{cloneOperationId}",
            routeValues: {
                project: project
            },
            body: cloneRequestBody
        });
    }

    /**
     * Get clone information.
     * 
     * @param project - Project ID or project name
     * @param cloneOperationId - Operation ID returned when we queue a clone operation
     */
    public async getTestCaseCloneInformation(
        project: string,
        cloneOperationId: number
        ): Promise<TestPlan.CloneTestCaseOperationInformation> {

        return this.beginRequest<TestPlan.CloneTestCaseOperationInformation>({
            apiVersion: "7.1-preview.2",
            routeTemplate: "{project}/_apis/testplan/TestCases/CloneTestCaseOperation/{cloneOperationId}",
            routeValues: {
                project: project,
                cloneOperationId: cloneOperationId
            }
        });
    }

    /**
     * Exports a set of test cases from a suite to a file. Currently supported  formats: xlsx
     * 
     * @param exportTestCaseRequestBody - A ExportTestCaseParams object.ExportTestCaseParams
     * @param project - Project ID or project name
     */
    public async exportTestCases(
        exportTestCaseRequestBody: TestPlan.ExportTestCaseParams,
        project: string
        ): Promise<ArrayBuffer> {

        return this.beginRequest<ArrayBuffer>({
            apiVersion: "7.1-preview.1",
            method: "POST",
            httpResponseType: "application/octet-stream",
            routeTemplate: "{project}/_apis/testplan/TestCases/TestCaseFile",
            routeValues: {
                project: project
            },
            body: exportTestCaseRequestBody
        });
    }

    /**
     * Clone test plan
     * 
     * @param cloneRequestBody - Plan Clone Request Body detail TestPlanCloneRequest
     * @param project - Project ID or project name
     * @param deepClone - Clones all the associated test cases as well
     */
    public async cloneTestPlan(
        cloneRequestBody: TestPlan.CloneTestPlanParams,
        project: string,
        deepClone?: boolean
        ): Promise<TestPlan.CloneTestPlanOperationInformation> {

        const queryValues: any = {
            deepClone: deepClone
        };

        return this.beginRequest<TestPlan.CloneTestPlanOperationInformation>({
            apiVersion: "7.1-preview.2",
            method: "POST",
            routeTemplate: "{project}/_apis/testplan/Plans/CloneOperation/{cloneOperationId}",
            routeValues: {
                project: project
            },
            queryParams: queryValues,
            body: cloneRequestBody
        });
    }

    /**
     * Get clone information.
     * 
     * @param project - Project ID or project name
     * @param cloneOperationId - Operation ID returned when we queue a clone operation
     */
    public async getCloneInformation(
        project: string,
        cloneOperationId: number
        ): Promise<TestPlan.CloneTestPlanOperationInformation> {

        return this.beginRequest<TestPlan.CloneTestPlanOperationInformation>({
            apiVersion: "7.1-preview.2",
            routeTemplate: "{project}/_apis/testplan/Plans/CloneOperation/{cloneOperationId}",
            routeValues: {
                project: project,
                cloneOperationId: cloneOperationId
            }
        });
    }

    /**
     * Get all the points inside a suite based on some filters
     * 
     * @param project - Project ID or project name
     * @param planId - ID of the test plan for which test points are requested.
     * @param suiteId - ID of the test suite for which test points are requested
     * @param testPointIds - ID of test points to fetch.
     * @param testCaseId - Get Test Points for specific test case Ids.
     * @param continuationToken - If the list of test point returned is not complete, a continuation token to query next batch of test points is included in the response header as "x-ms-continuationtoken". Omit this parameter to get the first batch of test points.
     * @param returnIdentityRef - If set to true, returns the AssignedTo field in TestCaseReference as IdentityRef object.
     * @param includePointDetails - If set to false, will get a smaller payload containing only basic details about the test point object
     * @param isRecursive - If set to true, will also fetch test points belonging to child suites recursively.
     */
    public async getPointsList(
        project: string,
        planId: number,
        suiteId: number,
        testPointIds?: string,
        testCaseId?: string,
        continuationToken?: string,
        returnIdentityRef?: boolean,
        includePointDetails?: boolean,
        isRecursive?: boolean
        ): Promise<VS_Services.PagedList<TestPlan.TestPoint>> {

        const queryValues: any = {
            testPointIds: testPointIds,
            testCaseId: testCaseId,
            continuationToken: continuationToken,
            returnIdentityRef: returnIdentityRef,
            includePointDetails: includePointDetails,
            isRecursive: isRecursive
        };

        return this.beginRequest<Response>({
            apiVersion: "7.1-preview.2",
            routeTemplate: "{project}/_apis/testplan/Plans/{planId}/Suites/{suiteId}/TestPoint/{pointIds}",
            routeValues: {
                project: project,
                planId: planId,
                suiteId: suiteId
            },
            queryParams: queryValues,
            returnRawResponse: true
        }).then(async response => {
            const body = <VS_Services.PagedList<TestPlan.TestPoint>>await response.text().then(deserializeVssJsonObject);
            body.continuationToken = response.headers.get("x-ms-continuationtoken");
            return body;
        });
    }

    /**
     * Update Test Points. This is used to Reset test point to active, update the outcome of a test point or update the tester of a test point
     * 
     * @param testPointUpdateParams - A TestPointUpdateParams Object.
     * @param project - Project ID or project name
     * @param planId - ID of the test plan for which test points are requested.
     * @param suiteId - ID of the test suite for which test points are requested.
     * @param includePointDetails - If set to false, will get a smaller payload containing only basic details about the test point object
     * @param returnIdentityRef - If set to true, returns the AssignedTo field in TestCaseReference as IdentityRef object.
     */
    public async updateTestPoints(
        testPointUpdateParams: TestPlan.TestPointUpdateParams[],
        project: string,
        planId: number,
        suiteId: number,
        includePointDetails?: boolean,
        returnIdentityRef?: boolean
        ): Promise<TestPlan.TestPoint[]> {

        const queryValues: any = {
            includePointDetails: includePointDetails,
            returnIdentityRef: returnIdentityRef
        };

        return this.beginRequest<TestPlan.TestPoint[]>({
            apiVersion: "7.1-preview.2",
            method: "PATCH",
            routeTemplate: "{project}/_apis/testplan/Plans/{planId}/Suites/{suiteId}/TestPoint/{pointIds}",
            routeValues: {
                project: project,
                planId: planId,
                suiteId: suiteId
            },
            queryParams: queryValues,
            body: testPointUpdateParams
        });
    }

    /**
     * Clone test suite
     * 
     * @param cloneRequestBody - Suite Clone Request Body detail TestSuiteCloneRequest
     * @param project - Project ID or project name
     * @param deepClone - Clones all the associated test cases as well
     */
    public async cloneTestSuite(
        cloneRequestBody: TestPlan.CloneTestSuiteParams,
        project: string,
        deepClone?: boolean
        ): Promise<TestPlan.CloneTestSuiteOperationInformation> {

        const queryValues: any = {
            deepClone: deepClone
        };

        return this.beginRequest<TestPlan.CloneTestSuiteOperationInformation>({
            apiVersion: "7.1-preview.2",
            method: "POST",
            routeTemplate: "{project}/_apis/testplan/Suites/CloneOperation/{cloneOperationId}",
            routeValues: {
                project: project
            },
            queryParams: queryValues,
            body: cloneRequestBody
        });
    }

    /**
     * Get clone information.
     * 
     * @param project - Project ID or project name
     * @param cloneOperationId - Operation ID returned when we queue a clone operation
     */
    public async getSuiteCloneInformation(
        project: string,
        cloneOperationId: number
        ): Promise<TestPlan.CloneTestSuiteOperationInformation> {

        return this.beginRequest<TestPlan.CloneTestSuiteOperationInformation>({
            apiVersion: "7.1-preview.2",
            routeTemplate: "{project}/_apis/testplan/Suites/CloneOperation/{cloneOperationId}",
            routeValues: {
                project: project,
                cloneOperationId: cloneOperationId
            }
        });
    }

}

export const TestPlanClientName = "TestHubRefresh-WebPlatform.ITestPlanRestClient";

export function getTestPlanClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): ITestPlanRestClient {
    return pageContext.getRestClient<ITestPlanRestClient>(TestPlanClientName, options);
}

RestClients.add(TestPlanClientName, { 
    factory: TestPlanRestClient,
    options: {
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
